import{a as r}from"./chunk-7LJURKHO.js";import i from"next/script.js";import{jsx as f}from"react/jsx-runtime";function s({pixelId:e}){r();let t;return Array.isArray(e)?t=e.reduce((n,o)=>(n+=`fbq('init', '${o}');`,n),""):t=`fbq('init', '${e}');`,f(i,{id:"fb-pixel",strategy:"afterInteractive",dangerouslySetInnerHTML:{__html:`
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
            	${t}
				fbq('track', 'PageView');
          `}})}export{s as a};
